import { determineEnvironment, EnvironmentType } from '@microsoft/portal-app/lib/environment';
import { getTelemetry } from '../../Telemetry/Telemetry';

const languageSettingsStorageKey = 'isSpeechSettingsEnabled';
const languageSettingsQueryParamKey = 'speechsettings';
const languageSettingsQueryParamValue = 'true';

enum LanguageSettingsStorageValue {
  TRUE = 'true',
  FALSE = 'false',
}

let showLanguageSettings: boolean | undefined = undefined;
export const showSpeechSettingsFlag = (location = window.location) => {
  if (determineEnvironment(location) === EnvironmentType.PPE) {
    showLanguageSettings = true;
    return showLanguageSettings;
  }

  showLanguageSettings = false;

  try {
    const searchParams = new URLSearchParams(location.search.toLocaleLowerCase());
    const showFlags = searchParams.get(languageSettingsQueryParamKey);
    if (showFlags !== null) {
      showLanguageSettings = showFlags === languageSettingsQueryParamValue;
      setLanguageSettingsInStorage(sessionStorage, showLanguageSettings);
    }
  } catch (err) {
    // Ignore errors
  }
  return showLanguageSettings || isLanguageSettingsInStorage(sessionStorage);
};

const setLanguageSettingsInStorage = (storage: Storage, shouldShowLangueSettings: boolean) => {
  const key = languageSettingsStorageKey;
  const telemetry = getTelemetry();
  const value = shouldShowLangueSettings ? LanguageSettingsStorageValue.TRUE : LanguageSettingsStorageValue.FALSE;
  try {
    storage.setItem(languageSettingsStorageKey, value);
  } catch (e) {
    telemetry.error('session-storage/write/language-settings/failed', {
      error: `Failed to write ${key}: ${value} to sessionStorage`,
    });
  }
};

const isLanguageSettingsInStorage = (storage: Storage): boolean => {
  const key = languageSettingsStorageKey;
  const telemetry = getTelemetry();
  try {
    return storage.getItem(languageSettingsStorageKey) === LanguageSettingsStorageValue.TRUE;
  } catch (e) {
    telemetry.error('session-storage/read/language-settings/failed', {
      error: `Failed to read key: ${key} from sessionStorage`,
    });
  }
  return false;
};
